module.exports = "/_next/static/images/chat-696442b625bd1b6e8d6f883ac48e3e45.svg";